import { render, staticRenderFns } from "./SectionTitleFrame.vue?vue&type=template&id=f08469be&scoped=true&"
import script from "./SectionTitleFrame.vue?vue&type=script&lang=js&"
export * from "./SectionTitleFrame.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitleFrame.vue?vue&type=style&index=0&id=f08469be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08469be",
  null
  
)

export default component.exports